import React from 'react';
import './loader.scss';

const Loader = () => (
  <div className="loader">Loading...</div>
);

export default Loader;
